import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { IAddress, IChangeCallback } from '../../_entities';

@Component({
	selector: 'add-edit-address-dialog',
	template: require('./add-edit-address-dialog.component.html')
})
export class AddEditAddressDialogComponent {
	private mode: ModalMode;
	private originalValue: IAddress;

	constructor() {
	}

	public edit(address: IAddress): void {
		this.mode = ModalMode.edit;
		this.title = "Update address";
		this.saveButtonText = "Save";
		this.originalValue = address;
		this.address = JSON.parse(JSON.stringify(address));
		this.modal.show();
	}

	public add(type: string): void {
		this.mode = ModalMode.add;
		this.title = "Add new address";
		this.saveButtonText = "Add";
		this.originalValue = null;
		this.address = this.getEmptyAddress(type);
		this.modal.show();
	}
	public onCancel(): void {
		this.modal.hide();
	}
	public onSave(): void {
		this.isSaving = true;

		let ccb: IChangeCallback<IAddress> = {
			id: null,
			oldValue: this.originalValue,
			newValue: this.address,
			reject: (message: string) => {
				this.isSaving = false;
				alert("Something went wrong...\r\n\r\nMessage: " + message)
			},
			resolve: () => {
				this.isSaving = false;
				this.modal.hide();
			}
		}
		if (this.mode == ModalMode.add) {
			this.onAddressAdded.emit(ccb);
		} else {
			this.onAddressUpdated.emit(ccb);
		}
	}

	private getEmptyAddress(type: string) {
		return {
			type: type,
			address1: null,
			address2: null,
			postalCode: null,
			city: null,
			country: null,
			lat: null,
			long: null
		};
	}

	title: string;
	saveButtonText: string = "Update";
	address: IAddress;
	isSaving: boolean = false;

	@ViewChild('modal') public modal: ModalDirective;
	@Output() onAddressAdded: EventEmitter<IChangeCallback<IAddress>> = new EventEmitter<IChangeCallback<IAddress>>();
	@Output() onAddressUpdated: EventEmitter<IChangeCallback<IAddress>> = new EventEmitter<IChangeCallback<IAddress>>();
}



enum ModalMode {
	edit,
	add
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/add-edit-address-dialog.component.ts